import { useVesselVisitBreadcrumbs } from '@planning/hooks/useVesselVisitBreadcrumbs'
import { VesselVisitItem } from '@planning/rt-stores/vesselVisit/VesselVisitItem'
import { Breadcrumbs, Header } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC, useMemo } from 'react'
import { Helmet } from 'react-helmet-async'

interface Props {
  vesselVisit: VesselVisitItem
}

export const VesselVisitDashboardHeader: FC<Props> = observer(({ vesselVisit }) => {
  const { breadcrumbs } = useVesselVisitBreadcrumbs(vesselVisit)

  if (!vesselVisit) return <></>

  const carrierVisitLabel = useMemo(() => {
    const vessel = vesselVisit?.vessels?.[0]?.data

    if (!vessel) return

    return `${vessel.name}:${vesselVisit.data.number}`
  }, [vesselVisit?.vessels, vesselVisit.data.number])

  const title = breadcrumbs.map(b => b.label).join(' - ')

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Breadcrumbs items={breadcrumbs} />
      <Header title={carrierVisitLabel} position='relative' />
    </>
  )
})
